import { Text } from '@react-pdf/renderer';
import styles from '../pro-report-pdf-styles';

function ProReportFooter() {
  return (
    <Text
      style={styles.footer}
      render={({ pageNumber, totalPages }) =>
        `Page ${pageNumber} of ${totalPages}`
      }
      fixed
    />
  );
}
export default ProReportFooter;
